export default "__VITE_ASSET__4e4fc91a__"